import React, { useEffect, useContext, useState } from 'react'
import CommonContext from '../../context/common/commonContext'
import LoaderContext from '../../context/loaders/loader.context'
import aboutImg from '../../assets/images/about-us.jpg'
import './StaticPages.css'
import Loader from '../../components/molecules/Loader'
import Seo from '../../components/molecules/Seo'

const url = new URL(window.location.href)
const absoluteUrl = url.origin + url.pathname

export const seoPages = {
    about: {
        title: `About Ledmax | Trusted Online Auctions`,
        description:
            'Discover our mission, values, and commitment to building a trusted online auction marketplace where buyers and sellers connect with confidence, transparency, security, and a seamless bidding experience.',
        canonical: absoluteUrl,
        keywords:
            'about us, company profile, online auctions, auction marketplace, trusted auction platform',
        image: `${url.origin}/assets/images/logo.png`,
    },

    how_to_bid: {
        title: `How to Bid Online | Ledmax`,
        description:
            'Learn how to participate in online auctions with our step-by-step bidding guide. Understand registration, bidding strategies, auction rules, and tips to increase your chances of winning.',
        canonical: absoluteUrl,
        keywords:
            'how to bid, online bidding guide, auction bidding, bidding process, auction help',
        image: `${url.origin}/assets/images/logo.png`,
    },

    privacy: {
        title: `Privacy Policy for Users | Ledmax`,
        description:
            'Read our Privacy Policy to understand how we collect, use, store, and protect your personal information. Learn about your privacy rights, data security practices, and compliance measures.',
        canonical: absoluteUrl,
        keywords:
            'privacy policy, data protection, user privacy, personal information, privacy practices',
        image: `${url.origin}/assets/images/logo.png`,
    },

    privacy_shield: {
        title: `Privacy Shield | Ledmax`,
        description:
            'Explore our commitment to data privacy and security through privacy compliance practices designed to safeguard user information and ensure responsible handling of personal data.',
        canonical: absoluteUrl,
        keywords: 'privacy shield, data security, privacy compliance, user data protection',
        image: `${url.origin}/assets/images/logo.png`,
    },

    terms: {
        title: `Terms and Conditions for Users | Ledmax`,
        description:
            'Review the terms and conditions that govern your use of our online auction platform, including account responsibilities, bidding rules, payment requirements, and service policies.',
        canonical: absoluteUrl,
        keywords: 'terms and conditions, terms of service, user agreement, auction policies',
        image: `${url.origin}/assets/images/logo.png`,
    },

    grading: {
        title: `Product Grading Guide | Ledmax`,
        description:
            'Understand our product grading standards and condition ratings. Learn how items are evaluated to provide transparent, consistent, and reliable information before you place a bid.',
        canonical: absoluteUrl,
        keywords:
            'product grading, condition ratings, quality standards, item grading, product condition',
        image: `${url.origin}/assets/images/logo.png`,
    },

    FAQ: {
        title: `Frequently Asked Questions (FAQs) | Ledmax`,
        description:
            'Find answers to frequently asked questions about registration, bidding, payments, shipping, account management, returns, and other essential auction marketplace topics.',
        canonical: absoluteUrl,
        keywords:
            'faq, frequently asked questions, auction help, bidding support, customer support',
        image: `${url.origin}/assets/images/logo.png`,
    },

    how_to: {
        title: `Help Center & Guides | Ledmax`,
        description:
            'Access helpful guides, tutorials, and support resources designed to help buyers and sellers navigate our online auction platform with ease and confidence.',
        canonical: absoluteUrl,
        keywords: 'help center, user guides, tutorials, auction guide, platform support',
        image: `${url.origin}/assets/images/logo.png`,
    },
}

const StaticPage = (props) => {
    let [pageData, setPageData] = useState('')
    let [pageTitle, setPageTitle] = useState('')
    let { getStaticPage, nonloginToken, staticPages, language, getLangPhrase, phrase } =
        useContext(CommonContext)
    let { setStaticPageload, isStaticPageLoad } = useContext(LoaderContext)
    useEffect(async () => {
        let { page } = props
        let payload = {
            page,
            nonloginToken,
        }
        setStaticPageload(true)
        getStaticPage(payload)
        getLangPhrase(language)
    }, [props.page, language])
    useEffect(() => {
        setStaticPageload(false)
        setPageData(staticPages)
        staticPageTitle(phrase)
    }, [staticPages, localStorage.getItem('language')])

    const staticPageTitle = (phrase) => {
        const capitalizeFirstLetter = (value) => {
            if (typeof value !== 'string' || value.length === 0) return value
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
        switch (props.page) {
            case 'about':
                setPageTitle(capitalizeFirstLetter(phrase.about))
                document.title = `About Us | Learn More About ${global.site_title}`
                break
            case 'how_to_bid':
                setPageTitle(capitalizeFirstLetter(phrase.how_to_bid))
                document.title = `How to Bid in Online Auctions | ${global.site_title}`
                break
            case 'privacy':
                setPageTitle(capitalizeFirstLetter(phrase.privacy_policy))
                document.title = `Privacy Policy | How ${global.site_title} Protects Your Data`
                break
            case 'privacy_shield':
                setPageTitle(capitalizeFirstLetter(phrase.privacy_shield))
                document.title = `Privacy Shield Framework | ${global.site_title}`
                break
            case 'terms':
                setPageTitle(capitalizeFirstLetter(phrase.terms_conditions))
                document.title = `Terms and Conditions | ${global.site_title}`
                break
            case 'grading':
                setPageTitle(capitalizeFirstLetter(phrase.product_grading))
                document.title = `Product Grading Guide | Quality Standards & Condition Ratings`
                break
            case 'FAQ':
                setPageTitle(capitalizeFirstLetter(phrase.faq))
                document.title = `Frequently Asked Questions (FAQs) | ${global.site_title}`
                break
            case 'how_to':
                setPageTitle(capitalizeFirstLetter(phrase.how_to))
                document.title = `Help Center & User Guides | ${global.site_title}`
                break
            default:
                break
        }
    }

    const checkLanguage = (data) => {
        switch (language) {
            case 'English':
                return data.for_english
            case 'French':
                return data.for_french
            case 'German':
                return data.for_german
            case 'Mandarin':
                return data.for_mandarin
            case 'Portugese':
                return data.for_portugese
            case 'BrazilPortugese':
                return data.for_brazilportugese
            case 'Spanish':
                return data.for_spanish
            default:
                return data.for_english
        }
    }
    const currentSeo = seoPages[props.page]

    return (
        <>
            {pageData !== '' ? (
                <>
                    <Seo {...currentSeo} siteName={global.site_title} />
                    <div>
                        {pageTitle != phrase.faq ? (
                            <div className="pp-banner">
                                <div className="pp-label">{pageTitle}</div>
                            </div>
                        ) : (
                            ''
                        )}

                        <div className="staticPageContent">
                            {pageData.content ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: checkLanguage(pageData),
                                    }}
                                ></div>
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: checkLanguage(pageData),
                                    }}
                                ></div>
                            )}
                        </div>
                    </div>
                </>
            ) : isStaticPageLoad ? (
                <Loader />
            ) : (
                'No data'
            )}
        </>
    )
}

export default StaticPage
